export const surveyForm = {
    thankyoumessage: "شكرًا لك على تقديم استطلاعك!",
    contributionMessage: "مساهمتك تعني الكثير بالنسبة لنا حتى نتمكن من جلب المزيد من التحسينات في المستقبل!",
    importance: "الأهمية (1-5)",
    score: "الدرجة (1-5)",
    serviceQuality: "جودة الخدمة",
    speedResponse: "سرعة الاستجابة على الطلبات المتغيرة",
    compliance: "الالتزام بالالتزامات التعاقدية",
    attentionDetail: "الانتباه للتفاصيل والدقة",
    definingRequests: "الفهم والمساعدة في تحديد الطلبات",
    financeDept: "سرعة وتعاون قسم الإدارة المالية لدينا",
    priceTerms: "السعر وشروط الدفع",
    complaintResolution: "سرعة حل الشكاوى",
    complaintWay: "طريقة حل الشكاوى",
    total: "المجموع %",
    suggestionsComments: "اقتراحات / تعليقات",
    textFieldLabel: "اكتب وصفك هنا....",
    submit: "إرسال",
    count: {
        count1: "١",
        count2: "٢",
        count3: "٣",
        count4: "٤",
        count5: "٥",
        count6: "٦",
        count7: "٧",
        count8: "٨",
        count9: "٩"
    },
};